import { Outlet, Link } from 'react-router-dom'
import { FaTruck, FaShieldAlt, FaClock, FaHome } from 'react-icons/fa'

export default function AuthLayout() {
  const currentYear = new Date().getFullYear()

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-primary-50 flex flex-col">
      {/* Header with logo and home link */}
      <header className="py-4 px-4 flex justify-center">
        <Link to="/" className="flex items-center gap-2.5 text-primary-600 hover:text-primary-700 transition-colors">
          <FaTruck className="text-2xl" />
          <span className="text-xl font-semibold">物流集货平台</span>
        </Link>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center py-8 px-4">
        <div className="max-w-md w-full">
          <Outlet />
          
          {/* Auth Features */}
          <div className="mt-6 flex justify-center gap-8">
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <FaShieldAlt className="text-primary-500" />
              <span>安全登录</span>
            </div>
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <FaClock className="text-primary-500" />
              <span>7x24服务</span>
            </div>
          </div>

          {/* Back to home link */}
          <div className="mt-6 text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm transition-colors"
            >
              <FaHome />
              <span>返回首页</span>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer - consistent with main layout */}
      <footer className="bg-gray-900 text-gray-300">
        <div className="container py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2.5 text-white">
            <FaTruck className="text-xl text-primary-400" />
            <span className="font-semibold">物流集货平台</span>
          </div>
          <p className="text-gray-500 text-sm">
            © {currentYear} 物流集货平台. 保留所有权利.
          </p>
        </div>
      </footer>
    </div>
  )
}
